import { Page } from "@/models/page-models/Page";

export const CustomersEdit: Page = {
  "path": "customers/:customerId",
  "name": "View/Edit Customer",
  "props": {
    "data": {
      "title": "View/Edit Customer",
      "printable": "FALSE",
      "url": "customers/:customerId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.data.status",
                  "label": "Type"
                },
                {
                  "type": "label",
                  "variable": "formData.data.reason",
                  "label": "Tag",
                  "showIf": "fn(NOT,{{formData.data.active}})"
                },
                {
                  "type": "label",
                  "label": "Status",
                  "labelType": "formula",
                  "formula": "fn(CONDITIONAL,{{formData.data.isDeleted}},Deleted,fn(HELPER_FN,agingStatus,{{formData.data}}))"
                },
                {
                  "type": "label",
                  "variable": "formData.data.createdAt",
                  "label": "Created At",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.data.createdAt}})"
                },
                {
                  "type": "label",
                  "variable": "formData.data.updatedAt",
                  "label": "Last Updated",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.data.updatedAt}})"
                },
                {
                  "type": "label",
                  "variable": "formData.data.region",
                  "label": "Region"
                },
                {
                  "type": "label",
                  "variable": "formData.data.dso.averageDaysToPay",
                  "label": "DSO",
                  "labelType": "formula",
                  "showIf": "{{formData.data.dso.averageDaysToPay}}",
                  "formula": "fn(CONCAT,{{formData.data.dso.averageDaysToPay}}, day(s))"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.data.name",
                  "class": "text-caption",
                  "labelType": "formula",
                  "formula": " Fields marked (*) required for Prospect Approval"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect'),&&,fn(NOT,{{formData.data.approvedProspect}}))"
            }
          ],
          "type": "genericGroup"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.name",
                  "label": "Customer Name (billing name as per CR)*",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nameArabic",
                  "label": "Arabic Name*",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.alias",
                  "label": "Alias*",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.customerCategory",
                  "label": "Category",
                  "disabled": "FALSE",
                  "items": "fetchedData.customerTypeByCategory.data.0.data",
                  "itemText": "en",
                  "itemValue": "en"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.customerTypeBySize",
                  "label": "Size",
                  "disabled": "FALSE",
                  "items": "fetchedData.customerTypeBySize.data.0.data",
                  "itemText": "alias",
                  "itemValue": "en"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.customerTypeByActivity",
                  "label": "Activity",
                  "disabled": "FALSE",
                  "items": "fetchedData.customerTypeByActivity.data.0.data",
                  "itemText": "en",
                  "itemValue": "en"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.customerType",
                  "label": "Regular / Miscellaneous",
                  "disabled": "FALSE",
                  "items": "[\"Regular\",\"Miscellaneous\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.schemeId",
                  "label": "Customer ID Type (Scheme ID)",
                  "disabled": "FALSE",
                  "items": "[{\"text\":\"VAT Number\",\"value\":\"VAT\"},{\"text\":\"Tax Identification Number\",\"value\":\"TIN\"},{\"text\":\"Commercial registration number\",\"value\":\"CRN\"},{\"text\":\"MOMRAH license\",\"value\":\"MOM\"},{\"text\":\"MHRSD license\",\"value\":\"MLS\"},{\"text\":\"700 Number\",\"value\":\"700\"},{\"text\":\"MISA license\",\"value\":\"SAG\"},{\"text\":\"National ID\",\"value\":\"NAT\"},{\"text\":\"GCC ID\",\"value\":\"GCC\"},{\"text\":\"Iqama Number\",\"value\":\"IQA\"},{\"text\":\"Passport ID\",\"value\":\"PAS\"},{\"text\":\"Other ID\",\"value\":\"OTH\"}]",
                  "itemText": "text",
                  "itemValue": "value",
                  "dropdownType": "static",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.data.customerType}},'),==,'Miscellaneous')"
                },
                {
                  "type": "input",
                  "variable": "formData.data.identification",
                  "label": "Customer ID #",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.data.customerType}},'),==,'Miscellaneous')"
                }
              ],
              "showIf": "fn(MATCH_ROLE,General Manager)"
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "arrayGroup",
                  "variable": "formData.data.socialMedia",
                  "label": "Website(s)",
                  "disabled": "FALSE",
                  "arrayItems": [
                    {
                      "name": "1",
                      "pageItems": [
                        {
                          "type": "input",
                          "variable": "link",
                          "label": "Link",
                          "disabled": "FALSE"
                        }
                      ]
                    }
                  ]
                },
                {
                  "type": "checkbox",
                  "variable": "formData.data.exportCustomer",
                  "label": "Export Customer",
                  "disabled": "fn(LOGICAL,fn(MATCH_ROLE,SALES_ACCOUNT_EXECUTIVE),||,fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer'))"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.currency",
                  "label": "Currency",
                  "items": "[\"SAR\",\"USD\"]",
                  "dropdownType": "static",
                  "disabled": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,SALES_ACCOUNT_EXECUTIVE),||,fn(NOT,{{formData.data.exportCustomer}})),||,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer'),&&,fn(NOT,fn(FEATURE_FLAG,Allow CUSTOMER Currency Edit))))"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "disabled": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer'),&&,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))),||,fn(LOGICAL,fn(LOGICAL,{{formData.data.active}},==,false),||,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(MATCH_ROLE,QA_MANAGER)),||,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(MATCH_ROLE,Customer Service | Outbound Warehouse)))))",
          "label": "Prospect Details"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.data.contactDetails",
          "label": "Contact Details*",
          "disabled": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer'),&&,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))),||,fn(LOGICAL,fn(LOGICAL,{{formData.data.active}},==,false),||,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(MATCH_ROLE,QA_MANAGER)),||,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(MATCH_ROLE,Customer Service | Outbound Warehouse)))))",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "prefix",
                  "label": "Prefix*",
                  "disabled": "FALSE",
                  "items": "[\"Mr\",\"Ms\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "firstName",
                  "label": "First Name*",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "lastName",
                  "label": "Last Name*",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "position",
                  "label": "Position",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "mobile",
                  "label": "Telephone*",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "email",
                  "label": "Email",
                  "disabled": "FALSE"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "mapautocomplete",
                  "variable": "formData.data.address",
                  "label": "Billing Address*",
                  "disabled": "FALSE",
                  "hideAliasFields": true
                },
                {
                  "type": "input",
                  "variable": "formData.data.address.alias_en",
                  "label": "Billing Address Alias (en)",
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.address}}"
                },
                {
                  "type": "input",
                  "variable": "formData.data.address.alias_ar",
                  "label": "Billing Address Alias (ar)",
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.address}}"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.billingContact",
                  "label": "Billing Contact*",
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.address}}",
                  "items": "formData.data.contactDetails",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "disabled": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer'),&&,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))),||,fn(LOGICAL,fn(LOGICAL,{{formData.data.active}},==,false),||,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(MATCH_ROLE,QA_MANAGER)),||,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(MATCH_ROLE,Customer Service | Outbound Warehouse)))))",
          "label": "Billing Details*"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.data.deliveryAddresses",
          "label": "Delivery Details*",
          "disabled": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer'),&&,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))),||,fn(LOGICAL,fn(LOGICAL,{{formData.data.active}},==,false),||,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(MATCH_ROLE,QA_MANAGER)),||,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(MATCH_ROLE,Customer Service | Outbound Warehouse)))))",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "ref",
                  "label": "Delivery Alias",
                  "disabled": "FALSE"
                },
                {
                  "type": "mapautocomplete",
                  "variable": "location",
                  "label": "Deilvery Location*",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "assignedContact",
                  "label": "Assigned Contact*",
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.contactDetails}}",
                  "items": "formData.data.contactDetails",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.data.VATNumber",
                  "class": "text-h6",
                  "labelType": "formula",
                  "formula": "VAT"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.VATNumber",
                  "label": "VAT #",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.data.VATProof",
                  "label": "",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            },
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.data.CRNumber",
                  "class": "text-h6",
                  "labelType": "formula",
                  "formula": "CR"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.CRNumber",
                  "label": "CR #",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.data.CRProof",
                  "label": "",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.supplierCode",
                  "label": "Cadis Supplier Code",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.addressCode",
                  "label": "National Address Short Code",
                  "disabled": "FALSE"
                },
                {
                  "type": "button",
                  "label": "Retrieve National Address",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getNationalAddressCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/national-address",
                        "arg2Key": "postData",
                        "arg2Value": "fetchedData.nationalAddress",
                        "arg3Key": "fnsAfterSubmit",
                        "arg3Value": "getCustomerData"
                      },
                      "name": "getNationalAddressCustomer"
                    }
                  ],
                  "disabled": "fn(NOT,{{formData.data.nationalAddress.addressCode}})",
                  "color": "secondary"
                },
                {
                  "type": "fileupload",
                  "variable": "formData.data.nationalAddressProof",
                  "label": "",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.streetName",
                  "label": "Street Name (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.buildNumber",
                  "label": "Building Number (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.buildNumber",
                  "label": "Building Number (ar)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.streetName",
                  "label": "Street Name (ar)",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.additionalNumber",
                  "label": "Additional Number (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.cityName",
                  "label": "City (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.cityName",
                  "label": "City (ar)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.additionalNumber",
                  "label": "Additional Number (ar)",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.postalCode",
                  "label": "Postal Code (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.district",
                  "label": "District (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.district",
                  "label": "District (ar)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.postalCode",
                  "label": "Postal Code (ar)",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.country",
                  "label": "Country (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.en.countryCode",
                  "label": "Country Code (en)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.countryCode",
                  "label": "Country Code (ar)",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.data.nationalAddress.ar.country",
                  "label": "Country (ar)",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "disabled": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer'),&&,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))),||,fn(LOGICAL,fn(LOGICAL,{{formData.data.active}},==,false),||,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Costing),||,fn(MATCH_ROLE,QA_MANAGER)),||,fn(LOGICAL,fn(MATCH_ROLE,Customer Service | Manager),||,fn(MATCH_ROLE,Customer Service | Outbound Warehouse)))))",
          "label": "Customer Details"
        },
        {
          "groupItems": [
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.termsAndConditions.tradeTerms.type",
                  "label": "Trade Terms",
                  "disabled": "FALSE",
                  "items": "fetchedData.tradeTermsDetails.data.0.data",
                  "itemText": "en",
                  "itemValue": "type",
                  "formula": "{{__item.en}} ({{__item.type}})"
                },
                {
                  "type": "input",
                  "variable": "formData.data.termsAndConditions.creditTerms.ceiling",
                  "label": "Credit Ceiling",
                  "unit": "SAR",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.termsAndConditions.paymentTerms.type",
                  "label": "Payment Terms",
                  "disabled": "FALSE",
                  "items": "fetchedData.paymentTermOptions.data.0.data",
                  "itemText": "en",
                  "itemValue": "alias",
                  "formula": "{{__item.alias}} ({{__item.en}})"
                }
              ]
            }
          ],
          "type": "genericGroup",
          "disabled": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer'),&&,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))),||,fn(LOGICAL,fn(NOT,{{formData.data.active}}),||,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))))",
          "label": "Commercial Details"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.data.assignedTo",
                  "label": "Assign To",
                  "disabled": "FALSE",
                  "items": "fetchedData.users.data",
                  "itemText": "displayName",
                  "itemValue": "_id"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.data.groups",
                  "label": "Select Groups",
                  "disabled": "FALSE",
                  "items": "fetchedData.customerGroups.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "multiple": true
                }
              ],
              "disabled": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer'),&&,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))),||,fn(LOGICAL,fn(NOT,{{formData.data.active}}),||,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)))))"
            }
          ],
          "type": "genericGroup",
          "label": "Sales Details"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "updateCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/businesspartners/{{formData.data._id}}",
                        "arg2Key": "postData",
                        "arg2Value": "formData.data",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "updateCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.active}}",
                  "color": "green"
                }
              ],
              "disabled": "fn(LOGICAL,fn(CONCAT,',{{formData.data.tag}},'),==,'Customer')",
              "showIf": "fn(MATCH_ROLE,Sales | Account Executive)"
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Approve",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "approveProspect",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/approve-prospect",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "approveProspect",
                      "executeIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect'),&&,fn(NOT,{{formData.data.approvedProspect}}))"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "approveCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/approve-customer",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "approveCustomer",
                      "executeIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect'),&&,{{formData.data.approvedProspect}})"
                    }
                  ],
                  "disabled": "fn(NOT,{{formData.data.active}})",
                  "showIf": "fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect')",
                  "color": "primary"
                },
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "updateCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/businesspartners/{{formData.data._id}}",
                        "arg2Key": "postData",
                        "arg2Value": "formData.data",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "updateCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.active}}",
                  "color": "green"
                },
                {
                  "type": "button",
                  "label": "Delete",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "deleteCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/delete",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "requestMethod",
                        "arg3Value": "PATCH",
                        "arg4Key": "redirectUrl",
                        "arg4Value": "/customers"
                      },
                      "name": "deleteCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect')",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(MATCH_ROLE,Sales | Manager)"
            },
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Enable",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "enableCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/enable-customer",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "enableCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,{{formData.data.active}})",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect'),&&,fn(MATCH_ROLE,Sales | Manager))"
            }
          ],
          "type": "genericGroup"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Enable",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "enableCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/enable-customer",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "enableCustomer",
                      "executeIf": "fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect')"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDefaultOverrideDate",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultOverrideDate",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.enableCustomerForm"
                      },
                      "name": "copyDefaultOverrideDate",
                      "executeIf": "fn(LOGICAL,'{{formData.data.tag}}',==,'Customer')"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "openEnableCustomerPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Enable Customer"
                      },
                      "name": "openEnableCustomerPopup",
                      "executeIf": "fn(LOGICAL,'{{formData.data.tag}}',==,'Customer')"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,{{formData.data.active}})",
                  "color": "primary"
                }
              ],
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Approve",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "approveProspect",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/approve-prospect",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "approveProspect",
                      "executeIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect'),&&,fn(NOT,{{formData.data.approvedProspect}}))"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "approveCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/approve-customer",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "approveCustomer",
                      "executeIf": "fn(LOGICAL,fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect'),&&,{{formData.data.approvedProspect}})"
                    }
                  ],
                  "disabled": "fn(NOT,{{formData.data.active}})",
                  "showIf": "fn(LOGICAL,'{{formData.data.tag}}',==,'Prospect')",
                  "color": "primary"
                },
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "updateCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/businesspartners/{{formData.data._id}}",
                        "arg2Key": "postData",
                        "arg2Value": "formData.data",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "PATCH"
                      },
                      "name": "updateCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.active}}",
                  "color": "green"
                },
                {
                  "type": "button",
                  "label": "Disable",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "disableCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/disable-customer",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "disableCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{formData.data.active}}",
                  "color": "error"
                },
                {
                  "type": "button",
                  "label": "Delete",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "deleteCustomer",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer/{{formData.data._id}}/delete",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "requestMethod",
                        "arg3Value": "PATCH",
                        "arg4Key": "redirectUrl",
                        "arg4Value": "/customers"
                      },
                      "name": "deleteCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "secondary"
                }
              ]
            }
          ],
          "showIf": "fn(LOGICAL,fn(NOT,{{formData.data.isDeleted}}),&&,fn(MATCH_ROLE,General Manager))",
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Enable Customer",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Select date for System Checking"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "fetchedData.enableCustomerForm.skipDisableUntil",
                  "label": "Skip Until",
                  "disabled": "FALSE",
                  "minDateFormula": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{TODAYS_DATE}},1),date-picker)"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Enable",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "enableCustomer",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/customer/{{formData.data._id}}/enable-customer",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.enableCustomerForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "enableCustomer"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getAssignUsers"
      },
      {
        "executionOrder": 1,
        "name": "getCustomerData"
      },
      {
        "executionOrder": 1,
        "name": "getCustomerGroups"
      },
      {
        "executionOrder": 1,
        "name": "getPaymentTerms"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getTradeTermDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=trade-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.tradeTermsDetails"
        },
        "name": "getTradeTermDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomerTypeByCategory",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=customer-type-by-category",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerTypeByCategory"
        },
        "name": "getCustomerTypeByCategory"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomerTypeBySize",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=customer-type-by-size",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerTypeBySize"
        },
        "name": "getCustomerTypeBySize"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomerTypeByActivity",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=customer-type-by-activity",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customerTypeByActivity"
        },
        "name": "getCustomerTypeByActivity"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyDefaultSocialMediaFields",
          "type":  "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultSocialMediaFields",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.data",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultSocialMediaFields",
        "executeIf": "fn(NOT,{{formData.data.socialMedia}})"
      }
    ],
    "functions": [
      {
        "name": "getCustomerData",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/customers/{{__params.customerId}}",
        "arg2Key": "storeInVar",
        "arg2Value": "formData"
      },
      {
        "name": "getAssignUsers",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/businesspartners/assignableUsers",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.users"
      },
      {
        "name": "getCustomerGroups",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/businesspartnergroups",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.customerGroups"
      },
      {
        "name": "getPaymentTerms",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/staticdata?type=payment-terms",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.paymentTermOptions"
      },
      {
        "name": "getDefaultOverrideDate",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "skipDisableUntil": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,{{TODAYS_DATE}},1),date-picker)"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultSocialMediaFields",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "socialMedia": []
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,CUSTOMER_SERVICE_MANAGER,ACCOUNTING_COSTING,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE,GENERAL_MANAGER,QA_MANAGER",
  "visible": false
}